import { useMemo } from 'react';

import contentStatuses from '@/shared/lib/constants/contentStatuses';
import Tag from '@/shared/ui/Tag';

type Props = {
  contentStatusId: number;
};

export default function ContentStatusTag({ contentStatusId }: Props) {
  const contentStatus = useMemo(() => {
    const current = contentStatuses.find((f) => f.value === contentStatusId);

    return current || contentStatuses[0];
  }, [contentStatusId]);

  return <Tag title={contentStatus.label} color={contentStatus.color} />;
}
